import { React, useEffect, useMemo, useState } from 'react';
import { GlobalContext, initialState } from './state/GlobalContext';

import axios from 'axios';

import BackgroundWrapper from './shared/BackgroundWrapper';
import Preloader from './shared/Preloader';
import WelcomeStep from './steps/WelcomeStep';
import GeneralStep from './steps/GeneralStep';

async function getTestData(){
    const response = await axios.get("/test-data");
    return response;
}

export default function Main() {
    const [state, setState] = useState(initialState);
    const contextValue = useMemo(() => {
        return {
            state,
            setState,
        };
    }, [state]);

    useEffect(() => {
        getTestData().then((res) => {
            setState({
                ...state,
                isLoading: false,
                testData: res.data,
                amountOfQuestions: res.data.questions.length,
            })
            document.getElementById('menopause-test-root').classList.remove('loading');
        })
    }, [null])
    
    return (
        <GlobalContext.Provider value={contextValue}>
            {  state.isLoading ? 
                <Preloader/>
                :
                state.thankYouPage ?
                    state.step == -1 ?
                        <WelcomeStep/>
                        :
                        <GeneralStep/>
                :
                <BackgroundWrapper currentStep={state.step} image={state.testData.general_settings.background}>
                    { state.step == -1 ?
                        <WelcomeStep/>
                        :
                        <GeneralStep/>
                    }
                </BackgroundWrapper>
            }
        </GlobalContext.Provider>
    );
}
